import { ref, watch, computed } from 'vue'

const STORAGE_KEY = 'kali_certificate_cart'

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

// Estado em escopo de módulo — compartilhado por todas as instâncias do componente,
// sobrevive ao fechar/reabrir o modal de checkout (só é perdido em hard refresh
// se o localStorage também for limpo, o que não é o caso).
const items = ref(load())

watch(items, (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    // localStorage pode falhar (modo privado, quota cheia) — carrinho segue só em memória
  }
}, { deep: true })

export function useCertificateCart() {
  const isEmpty = computed(() => items.value.length === 0)

  function addItem(certificateType) {
    const existing = items.value.find(i => i.certificate_type === certificateType)
    if (existing) {
      existing.quantity += 1
    } else {
      items.value.push({ certificate_type: certificateType, quantity: 1, addon: false })
    }
  }

  function removeItem(certificateType) {
    items.value = items.value.filter(i => i.certificate_type !== certificateType)
  }

  function incQuantity(certificateType) {
    const item = items.value.find(i => i.certificate_type === certificateType)
    if (item && item.quantity < 20) item.quantity += 1
  }

  function decQuantity(certificateType) {
    const item = items.value.find(i => i.certificate_type === certificateType)
    if (item && item.quantity > 1) item.quantity -= 1
  }

  function setAddon(certificateType, value) {
    const item = items.value.find(i => i.certificate_type === certificateType)
    if (item) item.addon = value
  }

  function clear() {
    items.value = []
  }

  return { items, isEmpty, addItem, removeItem, incQuantity, decQuantity, setAddon, clear }
}
